import apiClient from "./apiClient";

const listMenu = async () => {
  const response = await apiClient.get("/navigation/menu");
  return Array.isArray(response?.data) ? response.data : [];
};

const NavigationService = {
  listMenu,
};

export default NavigationService;
